import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import Spin from "antd/es/spin";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { DateRange } from "react-date-range";
import { InactivityContext } from "../InactivityContext";
import { Button, Input, Select } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined, CloseCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { ColumnsType, FilterDropdownProps } from "antd/es/table/interface";

type Permission = { id: number; name: string };
type Admin = {
    wizklub_ticket_sales_id: number;
    name: string;
    branch_name: string;
    student_class_name: string;
    saledate: string;
    agent_name: string;
    state_name: string;
    zone_name: string;
    admission_status: string;
};

interface Branch {
    branch_id: number;
    name: string;
    label: string;
}

interface State {
    state_id: number;
    name: string;
    label: string;
}

interface Zone {
    zone_id: number;
    name: string;
    label: string;
}


interface Class {
    class_name_id: number;
    name: string;
    label: string;
}

type Sales = {
    first_and_second_class_sales_count: number;
    third_to_ninth_class_sales_count: number;
}

type Agent = {
    id: number;
    username: string;
};

type AdmisssionStatus = {
    admission_status_id: number;
    admission_status: string;
}
interface Orientation {
    orientation_id: number;
    name: string;
    label: string;
}

type SortOrder = 'ascend' | 'descend' | null;

interface SortConfig {
    field: string;
    order: SortOrder;
}

type Trainer = {
    id:number;
    username:string;
}

const WizklubTrainerSales = () => {
    const routes = all_routes;
    const navigate = useNavigate();
    const data = exam;
    const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${month}-${day}-${year}`;
    const defaultValue = dayjs(formattedDate);
    const jwtToken = Cookies.get("authToken");
    const { userPermissions, webApi } = useUserPermissions();
    const [isLoading, setIsLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [permissions, setPermissions] = useState<Permission[]>([]);
    const [admin, setAdmin] = useState<Admin[]>([]);
    const [from, setFrom] = useState();
    const [to, setTo] = useState<number>();
    const [totalCount, setTotalCount] = useState();
    const [toastMessage, setToastMessage] = useState("");
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [agents, setAgents] = useState<Agent[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [searchText, setSearchText] = useState<string>("");
    const [branches, setBranches] = useState<Branch[]>([]);
    const [statesDropdowwn, setStatesDropdown] = useState<State[]>([]);
    const [zonesDropdown, setZonesDropdown] = useState<Zone[]>([]);
    const [trainers,setTrainers] = useState<Trainer[]>([]);
    const [showDateRange, setShowDateRange] = useState(false);
    const [showCalendar1, setShowCalendar1] = useState(false);
    const [selectedState, setSelectedState] = useState<number>(0);
    const [selectedZone, setSelectedZone] = useState(0);
    const [selectedBranch, setSelectedBranch] = useState(0);
    const [selectedClass, setSelectedClass] = useState(0);
    const [selectedTrainer, setSelectedTrainer] = useState(0);
    const handleClearState = () => setSelectedState(0);
    const handleClearZone = () => setSelectedZone(0);
    const handleClearBranch = () => setSelectedBranch(0);
    const handleClearClass = () => setSelectedClass(0);
    const handleClearTrainer = () => setSelectedTrainer(0);
    const { Option } = Select;
    const [classesDropdown, setClassesDropdown] = useState<Class[]>([]);
    const [salesCount, setSalesCount] = useState<Sales>({
        first_and_second_class_sales_count: 0,
        third_to_ninth_class_sales_count: 0,
    });
    const [admissonStatusDropdown, setAdmissionStatusDropdown] = useState<AdmisssionStatus[]>([]);
    const [selectedAdmissonStatus, setSelectedAdmissionStatus] = useState<number>(0);
    const [scsSearchText, setScsSearchText] = useState("");
    const [nameSearchText, setNameText] = useState("");
    const handleClearAdmissionStatus = () => setSelectedAdmissionStatus(0);
    const [selectedIsLastYearPaid, setSelectedIsLastYearPaid] = useState("");
    const [selectedOnCall, setSelectedOnCall] = useState("");
    const [orientationsDropdown, setOrientationDropdown] = useState<Orientation[]>([]);
    const [selectedOrientation, setSelectedOrientation] = useState<number>(() => {
        const saved = localStorage.getItem('WizklubSalesselectedOrientation');
        return saved !== null ? Number(saved) : 0;
    });
    const [sortConfigs, setSortConfigs] = useState<SortConfig[]>([]);
    useEffect(() => {
        localStorage.setItem('WizklubSalesselectedOrientation', selectedOrientation.toString());
    }, [selectedOrientation]);
    const handleClearOrientation = () => setSelectedOrientation(0);
    const [selectedPreviousOrientation, setSelectedPreviousOrientation] = useState<number>(() => {
        const saved = localStorage.getItem('SalesselectedPreviousOrientation');
        return saved !== null ? Number(saved) : 0;
    });
    useEffect(() => {
        localStorage.setItem('SalesselectedPreviousOrientation', selectedOrientation.toString());
    }, [selectedOrientation]);
    const handleClearPreviousOrientation = () => setSelectedPreviousOrientation(0);

    const inactivityContext = useContext(InactivityContext);
    if (!inactivityContext) {
        throw new Error("Header must be used within an InactivityProvider");
    }
    const {
        wizklubSalesSelectedClass,
        setWizklubSalesSelectedClass,
        wizklubSalesSelectedBranch,
        setWizklubSalesSelectedBranch,
        wizklubSalesSelectedBranchName,
        setWizklubSalesSelectedBranchName,
        wizklubSalesSelectedClassName,
        setWizklubSalesSelectedClassName,
        wizklubSalesSelectedAgent,
        setWizklubSalesSelectedAgent,
        wizklubSalesSelectedAgentName,
        setWizklubSalesSelectedAgentName,
        wizklubSalesState,
        setWizklubSalesState,
        wizklubSalesZone,
        setWizklubSalesZone,
        wizklubSalesStateName,
        setWizklubSalesStateName,
        wizklubSalesZoneName,
        setWizklubSalesZoneName,
    } = inactivityContext;
    const checkPermission = (action: any, subject: any) => {
        return userPermissions.some(
            (ability) => ability.action === action && ability.subject === subject
        );
    };

    const [dateRange, setDateRange] = useState(() => {
        const savedDates = localStorage.getItem("dateRange");
        if (savedDates) {
            const parsed = JSON.parse(savedDates);
            return parsed.map((range: any) => ({
                ...range,
                startDate: range.startDate ? new Date(range.startDate) : null,
                endDate: range.endDate ? new Date(range.endDate) : null,
            }));
        }
        // ✅ Start with null values
        return [
            {
                startDate: null,
                endDate: null,
                key: "selection",
            },
        ];
    });

    useEffect(() => {
        localStorage.setItem("dateRange", JSON.stringify(dateRange));
    }, [dateRange]);

    useEffect(() => {
        if (dateRange[0].startDate === null && dateRange[0].endDate === null) {
            handleResetData();
        }
    }, [dateRange]);

    const startDate =
        dateRange?.[0]?.startDate instanceof Date && !isNaN(dateRange[0].startDate)
            ? format(dateRange[0].startDate, "yyyy-MM-dd")
            : "";

    const endDate =
        dateRange?.[0]?.endDate instanceof Date && !isNaN(dateRange[0].endDate)
            ? format(dateRange[0].endDate, "yyyy-MM-dd")
            : "";

    useEffect(() => {
        if (!checkPermission("can_view_wizklub_trainer_sales", "wizklubticketsales")) {
            navigate(routes.crmLandingPage);
        } else {
            fetchData(currentPage, pageSize, searchText, selectedBranch, selectedClass, selectedTrainer, startDate,
                endDate, selectedState, selectedZone, selectedIsLastYearPaid, selectedOrientation, selectedPreviousOrientation, scsSearchText,
                nameSearchText);
        }
        fetchBranches(selectedState, wizklubSalesZone).then(setBranches);
        fetchStates().then(setStatesDropdown);
        fetchhZones(selectedState).then(setZonesDropdown);
        fetchClassesDropdown();
        fetchAgents();
        fetchAdmissionStatusDropdown();
        fetchOrientationDropdown();
        fetchTrainer();
    }, [userPermissions]);


    useEffect(() => {
        fetchBranches(selectedState, wizklubSalesZone).then(setBranches);
        fetchhZones(selectedState).then(setZonesDropdown);
    }, [selectedState, wizklubSalesZone])

    const handleResetData = () => {
        fetchData(currentPage, pageSize, searchText, selectedBranch, selectedClass, selectedTrainer, startDate,
                endDate, selectedState, selectedZone, selectedIsLastYearPaid, selectedOrientation, selectedPreviousOrientation, scsSearchText,
                nameSearchText);
        setShowCalendar1(false);
    };

    useEffect(() => {
        console.log("branch:", wizklubSalesSelectedAgent, wizklubSalesSelectedBranch, wizklubSalesSelectedClass)
    }, [wizklubSalesSelectedAgent, wizklubSalesSelectedBranch, wizklubSalesSelectedClass])

    const handleApplyClick = () => {
        if (dropdownMenuRef.current) {
            dropdownMenuRef.current.classList.remove("show");
        }
    };

    const handleFetchData = () => {
        if (startDate && endDate) {
           fetchData(currentPage, pageSize, searchText, selectedBranch, selectedClass, selectedTrainer, startDate,
                endDate, selectedState, selectedZone, selectedIsLastYearPaid, selectedOrientation, selectedPreviousOrientation, scsSearchText,
                nameSearchText);// Call fetchData with date range
            setShowCalendar1(false); // Hide the date range picker after selecting dates
        }
    };

    const handleBranchChange = (branchName: string) => {
        if (branchName === "") {
            setWizklubSalesSelectedBranch("");
            return;
        }

        const selectedBranch = branches.find(
            (branch) => branch.name === branchName
        );
        if (selectedBranch) {
            setWizklubSalesSelectedBranch(selectedBranch.branch_id.toString());
        }
    };

    const handleStateChange = (branchName: string) => {
        if (branchName === "") {
            setWizklubSalesState("");
            setSelectedState(0);
            fetchhZones(selectedState).then(setZonesDropdown);
            return;
        }

        const selectedBranch = statesDropdowwn.find(
            (branch) => branch.name === branchName
        );
        if (selectedBranch) {
            setWizklubSalesState(selectedBranch.state_id.toString());
            setSelectedState(selectedBranch.state_id);
            fetchhZones(selectedState).then(setZonesDropdown);
        }
    };

    const handleZoneChange = (branchName: string) => {
        if (branchName === "") {
            setWizklubSalesZone("");
            return;
        }

        const selectedBranch = zonesDropdown.find(
            (branch) => branch.name === branchName
        );
        if (selectedBranch) {
            setWizklubSalesZone(selectedBranch.zone_id.toString());
        }
    };

    const handleClassChange = async (className: string) => {
        if (className === "") {
            setWizklubSalesSelectedClass("");
            return;
        }

        const selectedClass = classesDropdown.find(
            (branch) => branch.name === className
        );
        if (selectedClass) {
            setWizklubSalesSelectedClass(selectedClass.class_name_id.toString());
        }
    };

    const handleAgentChangeFilter1 = async (AgentName: string) => {
        if (AgentName === "") {
            setWizklubSalesSelectedAgent("");
            return;
        }

        const selectedCategory = agents.find(
            (subCategory) => subCategory.username === AgentName
        );
        if (selectedCategory) {
            setWizklubSalesSelectedAgent(selectedCategory.id.toString());
        }
    };

    const getModalContainer = () => {
        const modalElement = document.getElementById("modal-datepicker");
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };

    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
        },
    };

    const fetchGroupsData = async (
        page: number,
        pageSize: number,
        searchText: string,
        branchName: number,
        className: number,
        agentName: number,
        startDate = "",
        endDate = "",
        stateName: number,
        zoneName: number,
        lastyearpaid: string,
        orientation: number,
        previous_orientation: number,
        scsNumber: string,
        name: string,
        sortConfigs: SortConfig[],

    ) => {
        let apiUrl = `${webApi}/wizklub/wizklub_trainer_sales/?page=${page}&page_size=${pageSize}&student__is_last_year_paid=${lastyearpaid}`
        if (searchText) apiUrl += `&search=${searchText}`;
        if (branchName) apiUrl += `&student__branch=${branchName}`;
        if (className) apiUrl += `&student__student_class=${className}`;
        if (agentName) apiUrl += `&sale_by_trainer=${agentName}`;
        if (startDate) apiUrl += `&from_date=${startDate}`;
        if (endDate) apiUrl += `&to_date=${endDate}`;
        if (stateName) apiUrl += `&state=${stateName}`;
        if (zoneName) apiUrl += `&zone=${zoneName}`;
        if (orientation) apiUrl += `&orientation=${orientation}`;
        if (previous_orientation) apiUrl += `&previous_orientation=${previous_orientation}`
        // if (lastyearpaid) apiUrl += `&student__is_last_year_paid=${lastyearpaid}`
        if (scsNumber) apiUrl += `&SCS_Number=${scsNumber}`;
        if (name) apiUrl += `&name=${name}`;
        if (sortConfigs.length > 0) {
            const orderingParams = sortConfigs
                .map(({ field, order }) =>
                    order === 'descend' ? `-${field}` : field
                )
                .join(',');
            apiUrl += `&ordering=${orderingParams}`;
        }

        const response = await fetch(apiUrl, options);
        if (!response.ok) {
            const errorData = await response.json();
            if (errorData.code === "token_not_valid") {
                navigate("/academic/sri-chaitanya/crm/landing-page");
            }
            throw new Error(errorData.detail || "Failed to fetch user data");
        }
        return await response.json();
    };

    const fetchPermissionsData = async () => {
        const resposne = await fetch(
            `${webApi}/user/get_permissions_dropdown/`,
            options
        );
        return await resposne.json();
    };

    const fetchBranches = async (state: any, zone: any) => {
        let url = `${webApi}/branches/wizklub_branches_dropdown/`;

        // Manually build query params
        let queryParams: string[] = [];

        if (state !== 0 && state !== "") {
            queryParams.push(`state_id=${state}`);
        }

        if (zone !== 0 && zone !== "") {
            queryParams.push(`zone_id=${zone}`);
        }

        if (queryParams.length > 0) {
            url += "?" + queryParams.join("&");
        }

        const response = await fetch(url, options);
        const data = await response.json();
        return data;
    };


    const fetchOrientationDropdown = async () => {
        const resposne = await fetch(
            `${webApi}/branches/branches_orientation_dropdown/`,
            options
        );
        const data = await resposne.json();
        setOrientationDropdown(data.results);
    };

    const fetchStates = async () => {
        const response = await fetch(
            `${webApi}/branches/branches_state_dropdown/`,
            options
        );
        const data = await response.json();
        return data.results;
    };

    const fetchhZones = async (state: any) => {
        const response = await fetch(
            `${webApi}/branches/branches_zone_dropdown/${state}/`,
            options
        );
        const data = await response.json();
        return data.results;
    };

    const fetchClassesDropdown = async () => {
        const resposne = await fetch(
            `${webApi}/branches/wizklub_class_names_dropdown/`,
            options
        );
        const data = await resposne.json();
        setClassesDropdown(data);
    };

    const fetchAdmissionStatusDropdown = async () => {
        const resposne = await fetch(
            `${webApi}/wizklub/admission_status_dropdown/`,
            options
        );
        const data = await resposne.json();
        setAdmissionStatusDropdown(data);
    };

     const fetchTrainer = async () => {
        const resposne = await fetch(
            `${webApi}/wizklub/wizklub_trainers_dropdown/`,
            options
        );
        const data = await resposne.json();
        setTrainers(data);
    };

    const fetchAgents = async () => {
        const resposne = await fetch(`${webApi}/teammgmt/get_team_members_by_teammgmt/2/`, options);
        const data = await resposne.json();
        setAgents(Array.isArray(data) ? data : []);
    };

    const fetchData = async (
        page: number,
        pageSize: number,
        searchText: string,
        branchName: number,
        className: number,
        agentName: number,
        startDate = "",
        endDate = "",
        stateName: number,
        zoneName: number,
        lastyearpaid: string,
        orientation: number,
        previous_orientation: number,
        scsNumber: string,
        name: string,
    ) => {
        setIsLoading(true); // Start loading
        try {
            const [groupsData] = await Promise.all([
                fetchGroupsData(page, pageSize, searchText, branchName, className, agentName, startDate, endDate, stateName, zoneName, lastyearpaid, orientation, previous_orientation, scsNumber, name, sortConfigs),
                // fetchPermissionsData(),
            ]);
            setTotalPages(groupsData.total_pages);
            setAdmin(groupsData.results);
            setSalesCount(groupsData.sales_counts);
            // setPermissions(permissionsData.results);

            setFrom(groupsData.from);
            setTo(groupsData.to);
            setTotalCount(groupsData.total_count);
            setToastMessage(groupsData.message || "submitted successfully!");
            setShowSuccessToast(true);
            setTotalCount(groupsData.total_count);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false); // Stop loading
        }
    };

    const handleTableChange = (pagination: any) => {
        const { current, pageSize } = pagination;
        setCurrentPage(current);
        setPageSize(pageSize);
        // fetchData(current, pageSize, searchText, wizklubSalesSelectedBranch, wizklubSalesSelectedClass,wizklubSalesSelectedAgent, startDate || undefined,
        //     endDate || undefined); // Fetch new data based on the updated pagination
    };

    const handleSearch = (value: string) => {
        setSearchText(value);
        // fetchData(currentPage, pageSize, value, wizklubSalesSelectedBranch, wizklubSalesSelectedClass,wizklubSalesSelectedAgent, startDate || undefined,
        //     endDate || undefined);
    };

    const [loading, setLoading] = useState(false);

    const [loading1, setLoading1] = useState(false);

    const fetchTodaySales = async () => {
        setLoading1(true);
        try {
            const response = await fetch(`${webApi}/wizklub/fetch_wizklub_today_sales_is_processed_false/`, options);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const data = await response.json();
           fetchData(currentPage, pageSize, searchText, selectedBranch, selectedClass, selectedTrainer, startDate,
                endDate, selectedState, selectedZone, selectedIsLastYearPaid, selectedOrientation, selectedPreviousOrientation, scsSearchText,
                nameSearchText);
        } catch (error) {
            console.error("Error fetching today's sales:", error);
        } finally {
            setLoading1(false);
        }
    };

    const handleExportClick = () => {
        let url = `${webApi}/exports/export_wizklub_sales/?token=${jwtToken}&from_date=${startDate}&to_date=${endDate}&search=${searchText}&student__branch=${wizklubSalesSelectedBranch}&student__student_class=${wizklubSalesSelectedClass}&agent=${wizklubSalesSelectedAgent}&state=${wizklubSalesState}&zone=${wizklubSalesZone}&student__is_last_year_paid=${selectedIsLastYearPaid}&on_call=${selectedOnCall}`;

        // Add orientation only if not 0
        if (selectedOrientation !== 0) {
            url += `&orientation=${selectedOrientation}`;
        }

        // Add previous_orientation only if not 0
        if (selectedPreviousOrientation !== 0) {
            url += `&previous_orientation=${selectedPreviousOrientation}`;
        }
        if (scsSearchText) {
            url += `&SCS_Number=${scsSearchText}`;
        }
        if (nameSearchText) {
            url += `&name=${nameSearchText}`;
        }

        window.location.href = url;
    };

    useEffect(() => {
        fetchData(currentPage, pageSize, searchText, selectedBranch, selectedClass, selectedTrainer, startDate,
                endDate, selectedState, selectedZone, selectedIsLastYearPaid, selectedOrientation, selectedPreviousOrientation, scsSearchText,
                nameSearchText);
    }, [currentPage, pageSize, searchText, selectedBranch, selectedZone, selectedTrainer, selectedState, selectedZone, selectedIsLastYearPaid, selectedOrientation, selectedPreviousOrientation, scsSearchText,
        nameSearchText, selectedOnCall, sortConfigs,selectedClass])


    const handleClearIsLastYearPaid = () => {
        setSelectedIsLastYearPaid("");
    };
    const handleClearOnCall = () => {
        setSelectedOnCall("");
    };
    const columns: ColumnsType<any> = [
        {
            title: (
                <span>
                    SCS Number
                    {sortConfigs.some(config => config.field === "student__SCS_Number") && (
                        <span style={{ marginLeft: 8 }}>
                            {sortConfigs.find(config => config.field === "student__SCS_Number")?.order === 'ascend' ? (
                                <ArrowUpOutlined style={{ color: '#1890ff' }} />
                            ) : (
                                <ArrowDownOutlined style={{ color: '#1890ff' }} />
                            )}
                        </span>
                    )}
                    {scsSearchText && (
                        <span style={{ marginLeft: 8, display: "inline-flex", alignItems: "center" }}>
                            <span style={{ color: "#1890ff", marginRight: 4 }}>({scsSearchText})</span>
                            <CloseCircleOutlined
                                onClick={() => {
                                    setScsSearchText("");
                                }}
                                style={{ color: "red", cursor: "pointer" }}
                            />
                        </span>
                    )}
                </span>
            ),
            dataIndex: "SCS_Number",
            key: "SCS_Number",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }: FilterDropdownProps) => (
                <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                    <Input
                        placeholder="Search SCS Number"
                        value={selectedKeys[0]}
                        onChange={(e) =>
                            setSelectedKeys(e.target.value ? [e.target.value] : [])
                        }
                        onPressEnter={() => {
                            confirm();
                            setScsSearchText(selectedKeys[0] as string);
                        }}
                        style={{ marginBottom: 8, display: "block" }}
                    />
                </div>
            ),
            filterIcon: (filtered: boolean) => (
                <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
            ),
            // onFilter: (value: string, record: { SCS_Number: { toString: () => string; }; }) =>
            //     record.SCS_Number?.toString().toLowerCase().includes((value as string).toLowerCase()),
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                checkPermission("can_view_wizklub_ticket_after_sale", "Records") ? (
                    <Link to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=10`}>
                        {text}
                    </Link>
                ) : (
                    <>{text}</>
                )
            ),
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            onHeaderCell: () => ({
                onClick: () => {
                    const newSortConfigs = [...sortConfigs];
                    const existingSortIndex = newSortConfigs.findIndex(
                        (config) => config.field === "student__SCS_Number"
                    );

                    // Cycle through sorting states (ascend → descend → remove)
                    if (existingSortIndex >= 0) {
                        const currentOrder = newSortConfigs[existingSortIndex].order;
                        if (currentOrder === 'ascend') {
                            newSortConfigs[existingSortIndex].order = 'descend';
                        } else {
                            newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
                        }
                    } else {
                        newSortConfigs.push({ field: "student__SCS_Number", order: "ascend" });
                    }

                    setSortConfigs(newSortConfigs);
                },
            }),

        },
        {
            title: (
                <span>
                    Name
                    {sortConfigs.some(config => config.field === "student__name") && (
                        <span style={{ marginLeft: 8 }}>
                            {sortConfigs.find(config => config.field === "student__name")?.order === 'ascend' ? (
                                <ArrowUpOutlined style={{ color: '#1890ff' }} />
                            ) : (
                                <ArrowDownOutlined style={{ color: '#1890ff' }} />
                            )}
                        </span>
                    )}
                    {nameSearchText && (
                        <span style={{ marginLeft: 8, display: "inline-flex", alignItems: "center" }}>
                            <span style={{ color: "#1890ff", marginRight: 4 }}>({nameSearchText})</span>
                            <CloseCircleOutlined
                                onClick={() => {
                                    setNameText("");
                                }}
                                style={{ color: "red", cursor: "pointer" }}
                            />
                        </span>
                    )}
                </span>
            ),
            dataIndex: "name",
            key: "name",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }: FilterDropdownProps) => (
                <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                    <Input
                        placeholder="Search Name"
                        value={selectedKeys[0]}
                        onChange={(e) =>
                            setSelectedKeys(e.target.value ? [e.target.value] : [])
                        }
                        onPressEnter={() => {
                            confirm();
                            setNameText(selectedKeys[0] as string);
                        }}
                        style={{ marginBottom: 8, display: "block" }}
                    />
                </div>
            ),
            filterIcon: (filtered: boolean) => (
                <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
            ),
            // onFilter: (value: string, record: { SCS_Number: { toString: () => string; }; }) =>
            //     record.SCS_Number?.toString().toLowerCase().includes((value as string).toLowerCase()),
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                checkPermission("can_view_wizklub_ticket_after_sale", "Records") ? (
                    <Link to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=10`}>
                        {text}
                    </Link>
                ) : (
                    <>{text}</>
                )
            ),
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            onHeaderCell: () => ({
                onClick: () => {
                    const newSortConfigs = [...sortConfigs];
                    const existingSortIndex = newSortConfigs.findIndex(
                        (config) => config.field === "student__name"
                    );

                    // Cycle through sorting states (ascend → descend → remove)
                    if (existingSortIndex >= 0) {
                        const currentOrder = newSortConfigs[existingSortIndex].order;
                        if (currentOrder === 'ascend') {
                            newSortConfigs[existingSortIndex].order = 'descend';
                        } else {
                            newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
                        }
                    } else {
                        newSortConfigs.push({ field: "student__name", order: "ascend" });
                    }

                    setSortConfigs(newSortConfigs);
                },
            }),

        },

        {
            title: (
                <span>
                    State
                    {sortConfigs.some(config => config.field === "state__name") && (
                        <span style={{ marginLeft: 8 }}>
                            {sortConfigs.find(config => config.field === "state__name")?.order === 'ascend' ? (
                                <ArrowUpOutlined style={{ color: '#1890ff' }} />
                            ) : (
                                <ArrowDownOutlined style={{ color: '#1890ff' }} />
                            )}
                        </span>
                    )}{selectedState !== 0 ? ` (${statesDropdowwn.find(state => state.state_id === selectedState)?.name})` : ""}
                    {selectedState !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearState}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>
            ),
            dataIndex: "state_name",
            key: "state_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Select State"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = statesDropdowwn.find((s) => s.state_id === value);
                            setSelectedKeys(selected ? [selected.name] : []);
                            setSelectedState(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {statesDropdowwn.map((state) => (
                            <Select.Option key={state.state_id} value={state.state_id}>
                                {state.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            onFilter: (value: any, record: { state_name: string }) => record.state_name === value,
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                checkPermission("can_view_wizklub_ticket_after_sale", "Records") ? (
                    <Link to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=10`}>
                        {text}
                    </Link>
                ) : (
                    <>{text}</>
                )
            ),
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            onHeaderCell: () => ({
                onClick: () => {
                    const newSortConfigs = [...sortConfigs];
                    const existingSortIndex = newSortConfigs.findIndex(
                        (config) => config.field === "state__name"
                    );

                    // Cycle through sorting states (ascend → descend → remove)
                    if (existingSortIndex >= 0) {
                        const currentOrder = newSortConfigs[existingSortIndex].order;
                        if (currentOrder === 'ascend') {
                            newSortConfigs[existingSortIndex].order = 'descend';
                        } else {
                            newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
                        }
                    } else {
                        newSortConfigs.push({ field: "state__name", order: "ascend" });
                    }

                    setSortConfigs(newSortConfigs);
                },
            }),

        },
        {
            title: (
                <span>
                    Zone {sortConfigs.some(config => config.field === "zone__name") && (
                        <span style={{ marginLeft: 8 }}>
                            {sortConfigs.find(config => config.field === "zone__name")?.order === 'ascend' ? (
                                <ArrowUpOutlined style={{ color: '#1890ff' }} />
                            ) : (
                                <ArrowDownOutlined style={{ color: '#1890ff' }} />
                            )}
                        </span>
                    )}{selectedZone !== 0 ? ` (${zonesDropdown.find(state => state.zone_id === selectedZone)?.name})` : ""}
                    {selectedZone !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearZone}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>
            ),
            dataIndex: "zone_name",
            key: "zone_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Select Zone"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = zonesDropdown.find((s) => s.zone_id === value);
                            setSelectedKeys(selected ? [selected.name] : []);
                            setSelectedZone(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {zonesDropdown.map((state) => (
                            <Select.Option key={state.zone_id} value={state.zone_id}>
                                {state.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            onFilter: (value: any, record: { orientation_name: string }) => record.orientation_name === value,
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                checkPermission("can_view_wizklub_ticket_after_sale", "Records") ? (
                    <Link to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=10`}>
                        {text}
                    </Link>
                ) : (
                    <>{text}</>
                )
            ),
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            onHeaderCell: () => ({
                onClick: () => {
                    const newSortConfigs = [...sortConfigs];
                    const existingSortIndex = newSortConfigs.findIndex(
                        (config) => config.field === "zone__name"
                    );

                    // Cycle through sorting states (ascend → descend → remove)
                    if (existingSortIndex >= 0) {
                        const currentOrder = newSortConfigs[existingSortIndex].order;
                        if (currentOrder === 'ascend') {
                            newSortConfigs[existingSortIndex].order = 'descend';
                        } else {
                            newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
                        }
                    } else {
                        newSortConfigs.push({ field: "zone__name", order: "ascend" });
                    }

                    setSortConfigs(newSortConfigs);
                },
            }),

        },
        {
            title: (
                <span>
                    Branch {sortConfigs.some(config => config.field === "student__branch__name") && (
                        <span style={{ marginLeft: 8 }}>
                            {sortConfigs.find(config => config.field === "student__branch__name")?.order === 'ascend' ? (
                                <ArrowUpOutlined style={{ color: '#1890ff' }} />
                            ) : (
                                <ArrowDownOutlined style={{ color: '#1890ff' }} />
                            )}
                        </span>
                    )}{selectedBranch !== 0 ? ` (${branches.find(state => state.branch_id === selectedBranch)?.name})` : ""}
                    {selectedBranch !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearBranch}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>
            ),
            dataIndex: "branch_name",
            key: "branch_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Select Branch"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = branches.find((s) => s.branch_id === value);
                            setSelectedKeys(selected ? [selected.name] : []);
                            setSelectedBranch(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {branches.map((state) => (
                            <Select.Option key={state.branch_id} value={state.branch_id}>
                                {state.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            onFilter: (value: any, record: { branch_name: string }) => record.branch_name === value,
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                checkPermission("can_view_wizklub_ticket_after_sale", "Records") ? (
                    <Link to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=10`}>
                        {text}
                    </Link>
                ) : (
                    <>{text}</>
                )
            ),
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            onHeaderCell: () => ({
                onClick: () => {
                    const newSortConfigs = [...sortConfigs];
                    const existingSortIndex = newSortConfigs.findIndex(
                        (config) => config.field === "student__branch__name"
                    );

                    // Cycle through sorting states (ascend → descend → remove)
                    if (existingSortIndex >= 0) {
                        const currentOrder = newSortConfigs[existingSortIndex].order;
                        if (currentOrder === 'ascend') {
                            newSortConfigs[existingSortIndex].order = 'descend';
                        } else {
                            newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
                        }
                    } else {
                        newSortConfigs.push({ field: "student__branch__name", order: "ascend" });
                    }

                    setSortConfigs(newSortConfigs);
                },
            }),

        },
        {
            title: (
                <span>
                    Orientation {sortConfigs.some(config => config.field === "student__orientation__name") && (
                        <span style={{ marginLeft: 8 }}>
                            {sortConfigs.find(config => config.field === "student__orientation__name")?.order === 'ascend' ? (
                                <ArrowUpOutlined style={{ color: '#1890ff' }} />
                            ) : (
                                <ArrowDownOutlined style={{ color: '#1890ff' }} />
                            )}
                        </span>
                    )}{selectedOrientation !== 0 ? ` (${orientationsDropdown.find(state => state.orientation_id === selectedOrientation)?.name})` : ""}
                    {selectedOrientation !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearOrientation}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>

            ),
            dataIndex: "orientation_name",
            key: "orientation_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Select Orientation"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = orientationsDropdown.find((s) => s.orientation_id === value);
                            setSelectedKeys(selected ? [selected.name] : []);
                            setSelectedOrientation(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {orientationsDropdown.map((state) => (
                            <Select.Option key={state.orientation_id} value={state.orientation_id}>
                                {state.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            onFilter: (value: any, record: { orientation_name: string }) => record.orientation_name === value,
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                checkPermission("can_view_wizklub_ticket_after_sale", "Records") ? (
                    <Link to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=10`}>
                        {text}
                    </Link>
                ) : (
                    <>{text}</>
                )
            ),
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            onHeaderCell: () => ({
                onClick: () => {
                    const newSortConfigs = [...sortConfigs];
                    const existingSortIndex = newSortConfigs.findIndex(
                        (config) => config.field === "student__orientation__name"
                    );

                    // Cycle through sorting states (ascend → descend → remove)
                    if (existingSortIndex >= 0) {
                        const currentOrder = newSortConfigs[existingSortIndex].order;
                        if (currentOrder === 'ascend') {
                            newSortConfigs[existingSortIndex].order = 'descend';
                        } else {
                            newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
                        }
                    } else {
                        newSortConfigs.push({ field: "student__orientation__name", order: "ascend" });
                    }

                    setSortConfigs(newSortConfigs);
                },
            }),

        },
        {
            title: (
                <span>
                    Previous Orientation {sortConfigs.some(config => config.field === "student__previous_orientation__name") && (
                        <span style={{ marginLeft: 8 }}>
                            {sortConfigs.find(config => config.field === "student__previous_orientation__name")?.order === 'ascend' ? (
                                <ArrowUpOutlined style={{ color: '#1890ff' }} />
                            ) : (
                                <ArrowDownOutlined style={{ color: '#1890ff' }} />
                            )}
                        </span>
                    )}{selectedPreviousOrientation !== 0 ? ` (${orientationsDropdown.find(state => state.orientation_id === selectedPreviousOrientation)?.name})` : ""}
                    {selectedPreviousOrientation !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearPreviousOrientation}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>

            ),
            dataIndex: "previous_orientation_name",
            key: "previous_orientation_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Select Previous Orientation"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = orientationsDropdown.find((s) => s.orientation_id === value);
                            setSelectedKeys(selected ? [selected.name] : []);
                            setSelectedPreviousOrientation(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {orientationsDropdown.map((state) => (
                            <Select.Option key={state.orientation_id} value={state.orientation_id}>
                                {state.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            onFilter: (value: any, record: { orientation_name: string }) => record.orientation_name === value,
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                checkPermission("can_view_wizklub_ticket_after_sale", "Records") ? (
                    <Link to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=10`}>
                        {text}
                    </Link>
                ) : (
                    <>{text}</>
                )
            ),
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            onHeaderCell: () => ({
                onClick: () => {
                    const newSortConfigs = [...sortConfigs];
                    const existingSortIndex = newSortConfigs.findIndex(
                        (config) => config.field === "student__previous_orientation__name"
                    );

                    // Cycle through sorting states (ascend → descend → remove)
                    if (existingSortIndex >= 0) {
                        const currentOrder = newSortConfigs[existingSortIndex].order;
                        if (currentOrder === 'ascend') {
                            newSortConfigs[existingSortIndex].order = 'descend';
                        } else {
                            newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
                        }
                    } else {
                        newSortConfigs.push({ field: "student__previous_orientation__name", order: "ascend" });
                    }

                    setSortConfigs(newSortConfigs);
                },
            }),

        },
        {
            title: (
                <span>
                    Class {sortConfigs.some(config => config.field === "student__student_class__class_sequence") && (
                        <span style={{ marginLeft: 8 }}>
                            {sortConfigs.find(config => config.field === "student__student_class__class_sequence")?.order === 'ascend' ? (
                                <ArrowUpOutlined style={{ color: '#1890ff' }} />
                            ) : (
                                <ArrowDownOutlined style={{ color: '#1890ff' }} />
                            )}
                        </span>
                    )}{selectedClass !== 0 ? ` (${classesDropdown.find(state => state.class_name_id === selectedClass)?.name})` : ""}
                    {selectedClass !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearClass}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>
            ),
            dataIndex: "student_class_name",
            key: "student_class_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Select Class"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = classesDropdown.find((s) => s.class_name_id === value);
                            setSelectedKeys(selected ? [selected.name] : []);
                            setSelectedClass(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {classesDropdown.map((state) => (
                            <Select.Option key={state.class_name_id} value={state.class_name_id}>
                                {state.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            onFilter: (value: any, record: { student_class_name: string }) => record.student_class_name === value,
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                checkPermission("can_view_wizklub_ticket_after_sale", "Records") ? (
                    <Link to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=10`}>
                        {text}
                    </Link>
                ) : (
                    <>{text}</>
                )
            ),
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            onHeaderCell: () => ({
                onClick: () => {
                    const newSortConfigs = [...sortConfigs];
                    const existingSortIndex = newSortConfigs.findIndex(
                        (config) => config.field === "student__student_class__class_sequence"
                    );

                    // Cycle through sorting states (ascend → descend → remove)
                    if (existingSortIndex >= 0) {
                        const currentOrder = newSortConfigs[existingSortIndex].order;
                        if (currentOrder === 'ascend') {
                            newSortConfigs[existingSortIndex].order = 'descend';
                        } else {
                            newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
                        }
                    } else {
                        newSortConfigs.push({ field: "student__student_class__class_sequence", order: "ascend" });
                    }

                    setSortConfigs(newSortConfigs);
                },
            }),
        },
        // {
        //     title: (
        //         <span>
        //             Status{selectedAdmissonStatus !== 0 ? ` (${admissonStatusDropdown.find(state => state.admission_status_id === selectedAdmissonStatus)?.admission_status})` : ""}
        //             {selectedAdmissonStatus !== 0 && (
        //                 <CloseCircleOutlined
        //                     onClick={handleClearAdmissionStatus}
        //                     style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
        //                 />
        //             )}
        //         </span>
        //     ),
        //     dataIndex: "admission_status",
        //     key: "admission_status",
        //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        //         <div style={{ padding: 8 }}>
        //             <Select
        //                 showSearch
        //                 placeholder="Select Admission Status"
        //                 style={{ width: 188 }}
        //                 value={selectedKeys[0]}
        //                 onChange={(value) => {
        //                     const selected = admissonStatusDropdown.find((s) => s.admission_status_id === value);
        //                     setSelectedKeys(selected ? [selected.admission_status] : []);
        //                     setSelectedState(value);
        //                     confirm();
        //                 }}
        //                 allowClear
        //                 filterOption={(input, option) =>
        //                     typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
        //                 }
        //             >
        //                 {admissonStatusDropdown.map((state) => (
        //                     <Select.Option key={state.admission_status_id} value={state.admission_status_id}>
        //                         {state.admission_status}
        //                     </Select.Option>
        //                 ))}
        //             </Select>
        //         </div>
        //     ),
        //     onFilter: (value: any, record: { state_name: string }) => record.state_name === value,
        // },
        {
            title: (
                <span>
                    isLastYearPaid {sortConfigs.some(config => config.field === "student__is_last_year_paid") && (
                        <span style={{ marginLeft: 8 }}>
                            {sortConfigs.find(config => config.field === "student__is_last_year_paid")?.order === 'ascend' ? (
                                <ArrowUpOutlined style={{ color: '#1890ff' }} />
                            ) : (
                                <ArrowDownOutlined style={{ color: '#1890ff' }} />
                            )}
                        </span>
                    )}
                    {selectedIsLastYearPaid !== "" && (
                        <>
                            {`${selectedIsLastYearPaid ? ' (Yes)' : ' (No)'}`}
                            <CloseCircleOutlined
                                onClick={handleClearIsLastYearPaid}
                                style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                            />
                        </>
                    )}
                </span>
            ),
            dataIndex: "is_last_year_paid",
            key: "is_last_year_paid",
            render: (value: boolean) => (value ? "Yes" : "No"),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        placeholder="Select Payment Status"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            setSelectedKeys([value]);
                            setSelectedIsLastYearPaid(value); // <-- Updated state handler
                            confirm();
                        }}
                        allowClear
                    >
                        <Select.Option value={true}>Yes</Select.Option>
                        <Select.Option value={false}>No</Select.Option>
                    </Select>
                </div>
            ),
            // onFilter: (value: boolean, record: { is_last_year_paid: boolean }) =>
            //     record.is_last_year_paid === value,
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            onHeaderCell: () => ({
                onClick: () => {
                    const newSortConfigs = [...sortConfigs];
                    const existingSortIndex = newSortConfigs.findIndex(
                        (config) => config.field === "student__is_last_year_paid"
                    );

                    // Cycle through sorting states (ascend → descend → remove)
                    if (existingSortIndex >= 0) {
                        const currentOrder = newSortConfigs[existingSortIndex].order;
                        if (currentOrder === 'ascend') {
                            newSortConfigs[existingSortIndex].order = 'descend';
                        } else {
                            newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
                        }
                    } else {
                        newSortConfigs.push({ field: "student__is_last_year_paid", order: "ascend" });
                    }

                    setSortConfigs(newSortConfigs);
                },
            }),

        },
        {
            title: (<span>Sale Date {sortConfigs.some(config => config.field === "sale_date") && (
                <span style={{ marginLeft: 8 }}>
                    {sortConfigs.find(config => config.field === "sale_date")?.order === 'ascend' ? (
                        <ArrowUpOutlined style={{ color: '#1890ff' }} />
                    ) : (
                        <ArrowDownOutlined style={{ color: '#1890ff' }} />
                    )}
                </span>
            )}</span>),
            dataIndex: "saledate",
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                checkPermission("can_view_wizklub_ticket_after_sale", "Records") ? (
                    <Link to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=10`}>
                        {text}
                    </Link>
                ) : (
                    <>{text}</>
                )
            ),
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            onHeaderCell: () => ({
                onClick: () => {
                    const newSortConfigs = [...sortConfigs];
                    const existingSortIndex = newSortConfigs.findIndex(
                        (config) => config.field === "sale_date"
                    );

                    // Cycle through sorting states (ascend → descend → remove)
                    if (existingSortIndex >= 0) {
                        const currentOrder = newSortConfigs[existingSortIndex].order;
                        if (currentOrder === 'ascend') {
                            newSortConfigs[existingSortIndex].order = 'descend';
                        } else {
                            newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
                        }
                    } else {
                        newSortConfigs.push({ field: "sale_date", order: "ascend" });
                    }

                    setSortConfigs(newSortConfigs);
                },
            }),

        },
        // {
        //     title: (
        //         <span>
        //             On Call
        //             {sortConfigs.some(config => config.field === "on_call_value") && (
        //                 <span style={{ marginLeft: 8 }}>
        //                     {sortConfigs.find(config => config.field === "on_call_value")?.order === 'ascend' ? (
        //                         <ArrowUpOutlined style={{ color: '#1890ff' }} />
        //                     ) : (
        //                         <ArrowDownOutlined style={{ color: '#1890ff' }} />
        //                     )}
        //                 </span>
        //             )}
        //             {selectedOnCall !== "" && (
        //                 <>
        //                     {`${selectedOnCall ? ' (Yes)' : ' (No)'}`}
        //                     <CloseCircleOutlined
        //                         onClick={handleClearOnCall}
        //                         style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
        //                     />
        //                 </>
        //             )}
        //         </span>
        //     ),
        //     dataIndex: "on_call",
        //     key: "on_call",
        //     // render: (value: boolean) => (value ? "Yes" : "No"),
        //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        //         <div style={{ padding: 8 }}>
        //             <Select
        //                 placeholder="On Call"
        //                 style={{ width: 188 }}
        //                 value={selectedKeys[0]}
        //                 onChange={(value) => {
        //                     setSelectedKeys([value]);
        //                     setSelectedOnCall(value); // <-- Updated state handler
        //                     confirm();
        //                 }}
        //                 allowClear
        //             >
        //                 <Select.Option value={true}>Yes</Select.Option>
        //                 <Select.Option value={false}>No</Select.Option>
        //             </Select>
        //         </div>
        //     ),
        //     onFilter: (value: boolean, record: { on_call: boolean }) =>
        //         record.on_call === value,
        //     sorter: true,
        //     sortDirections: ['ascend', 'descend'],
        //     onHeaderCell: () => ({
        //         onClick: () => {
        //             const newSortConfigs = [...sortConfigs];
        //             const existingSortIndex = newSortConfigs.findIndex(
        //                 (config) => config.field === "on_call_value"
        //             );

        //             // Cycle through sorting states (ascend → descend → remove)
        //             if (existingSortIndex >= 0) {
        //                 const currentOrder = newSortConfigs[existingSortIndex].order;
        //                 if (currentOrder === 'ascend') {
        //                     newSortConfigs[existingSortIndex].order = 'descend';
        //                 } else {
        //                     newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
        //                 }
        //             } else {
        //                 newSortConfigs.push({ field: "on_call_value", order: "ascend" });
        //             }

        //             setSortConfigs(newSortConfigs);
        //         },
        //     }),
        // },
        {
            title: (
                <span>
                    Trainer
                    {sortConfigs.some(config => config.field === "final_agent_username") && (
                        <span style={{ marginLeft: 8 }}>
                            {sortConfigs.find(config => config.field === "final_agent_username")?.order === 'ascend' ? (
                                <ArrowUpOutlined style={{ color: '#1890ff' }} />
                            ) : (
                                <ArrowDownOutlined style={{ color: '#1890ff' }} />
                            )}
                        </span>
                    )}
                    {selectedTrainer !== 0 ? ` (${trainers.find(state => state.id === selectedTrainer)?.username})` : ""}
                    {selectedTrainer !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearTrainer}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>
            ),
            dataIndex: "trainer_name",
            key: "trainer_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Select Trainer"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = trainers.find((s) => s.id === value);
                            setSelectedKeys(selected ? [selected.username] : []);
                            setSelectedTrainer(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {trainers.map((state) => (
                            <Select.Option key={state.id} value={state.id}>
                                {state.username}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            onFilter: (value: any, record: { trainer_name: string }) => record.trainer_name === value,
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                checkPermission("can_view_wizklub_ticket_after_sale", "Records") ? (
                    <Link to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=10`}>
                        {text}
                    </Link>
                ) : (
                    <>{text}</>
                )
            ),
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            onHeaderCell: () => ({
                onClick: () => {
                    const newSortConfigs = [...sortConfigs];
                    const existingSortIndex = newSortConfigs.findIndex(
                        (config) => config.field === "final_agent_username"
                    );

                    // Cycle through sorting states (ascend → descend → remove)
                    if (existingSortIndex >= 0) {
                        const currentOrder = newSortConfigs[existingSortIndex].order;
                        if (currentOrder === 'ascend') {
                            newSortConfigs[existingSortIndex].order = 'descend';
                        } else {
                            newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
                        }
                    } else {
                        newSortConfigs.push({ field: "final_agent_username", order: "ascend" });
                    }

                    setSortConfigs(newSortConfigs);
                },
            }),

        }
    ];

    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    {/* Page Header */}
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h3 className="page-title mb-1">
                                Wizklub Trainer Sales
                            </h3>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={routes.wizklubTrainerDashboard}>Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Wizklub Trainer Sales
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                            {/* {checkPermission("can_export_wizklub_sales", "wizklubticketsales") && (
                                <button className="btn btn-primary me-2" onClick={handleExportClick} disabled={loading}>
                                    {loading ? (
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    ) : (
                                        "Export"
                                    )}
                                </button>
                            )} */}
                            {/* {checkPermission("fetch_wizklub_today_sales", "wizklubticketsales") && (
                                <button className="btn btn-primary me-2" onClick={fetchTodaySales} disabled={loading1}>
                                    {loading1 ? (
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    ) : (
                                        "Refresh"
                                    )}
                                </button>
                            )} */}
                        </div>
                    </div>
                    {/* /Page Header */}
                    {/* Guardians List */}
                    <div
                        className="card "
                        style={{
                            width: "100%",
                            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                            borderRadius: "10px",
                        }}
                    >
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                            <h4 className="mb-3">Wizklub Trainer Sales</h4>
                            <div
                                className="d-flex align-items-center flex-wrap"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                }}
                            >
                                <div className="sales-data" style={{ marginRight: "35px" }}>

                                    <div><strong>1st & 2nd Class:</strong> {salesCount.first_and_second_class_sales_count}</div>
                                    <div><strong>3rd–9th Class:</strong> {salesCount.third_to_ninth_class_sales_count}</div>
                                </div>

                                <div
                                    className="d-flex align-items-center"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <div style={{ position: "relative" }}>
                                        <div
                                            onClick={() => setShowCalendar1(!showCalendar1)}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "8px 15px",
                                                background: "white",
                                                borderRadius: "20px",
                                                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                                                fontSize: "12px",
                                                fontWeight: "bold",
                                                color: "#34303D",
                                                cursor: "pointer",
                                                border: "1px solid #ddd",
                                                minWidth: "200px",
                                                justifyContent: "center",
                                                marginRight: "5px",
                                                marginBottom: "7px",
                                            }}
                                        >
                                            {dateRange[0].startDate && dateRange[0].endDate
                                                ? `${format(dateRange[0].startDate, "dd MMM yy")} – ${format(dateRange[0].endDate, "dd MMM yy")}`
                                                : "Choose date"}
                                            <span style={{ marginLeft: "10px" }}>▼</span>
                                        </div>

                                        {showCalendar1 && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    zIndex: 2000,
                                                    background: "white",
                                                    borderRadius: "10px",
                                                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                                    padding: "5px",
                                                    left: "-130px",
                                                }}
                                            >
                                                <DateRange
                                                    ranges={dateRange}
                                                    onChange={(item) =>
                                                        setDateRange([
                                                            {
                                                                startDate: item.selection.startDate || null,
                                                                endDate: item.selection.endDate || null,
                                                                key: "selection",
                                                            },
                                                        ])
                                                    }
                                                    moveRangeOnFirstSelection={false}
                                                    rangeColors={["blue"]}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <button
                                        className="btn btn-primary"
                                        style={{
                                            backgroundColor: "#28a745",
                                            borderColor: "#28a745",
                                            color: "#fff",
                                            height: "38px",
                                            padding: "6px 12px",
                                            display: "flex",
                                            alignItems: "center",
                                            // marginTop: "0.5rem",
                                            marginBottom: "7px",
                                            borderRadius: "19px",
                                        }}
                                        onClick={handleFetchData}
                                    >
                                        Search
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        style={{
                                            backgroundColor: "#dc3545", // Red background
                                            borderColor: "#dc3545",     // Red border
                                            color: "#fff",
                                            height: "38px",
                                            padding: "6px 12px",
                                            display: "flex",
                                            alignItems: "center",
                                            marginBottom: "7px",
                                            borderRadius: "19px",
                                            marginLeft: "5px",
                                        }}
                                        onClick={() => {

                                            setDateRange([
                                                {
                                                    startDate: null,
                                                    endDate: null,
                                                    key: "selection",
                                                },
                                            ]);
                                            // handleResetData()
                                        }}
                                    >
                                        Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0 py-3">
                            <div
                                className="serch-global text-right"
                                style={{ marginRight: "15px" }}
                            >
                                <input
                                    type="search"
                                    className="form-control form-control-sm mb-3 w-auto float-end"
                                    value={searchText}
                                    placeholder="Search"
                                    onChange={(e) => handleSearch(e.target.value)}
                                    aria-controls="DataTables_Table_0"
                                ></input>
                            </div>
                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        height: "100vh",
                                        paddingTop: "20px",
                                    }}
                                >
                                    <Spin /> {/* Display loader while loading */}
                                </div>
                            ) : (
                                <Table
                                    columns={columns}
                                    dataSource={admin}
                                    Selection={true}
                                    pagination={{
                                        current: currentPage,
                                        pageSize: pageSize,
                                        locale: { items_per_page: "" },
                                        nextIcon: <span>Next</span>,
                                        prevIcon: <span>Prev</span>,
                                        defaultPageSize: 10,
                                        showSizeChanger: true,
                                        total: totalCount,
                                        showTotal: (total: any, range: any[]) =>
                                            `${range[0]}-${range[1]} of ${total}`,
                                        pageSizeOptions: ["10", "25", "50", "100"],
                                    }}
                                    onChange={handleTableChange} // Move this outside of pagination
                                    onSearch={handleSearch}
                                />
                            )}
                        </div>
                    </div>
                    {/* /Guardians List */}
                </div>
            </div>
            <>
                {/* Delete Modal */}
                <div className="modal fade" id="delete-modal">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <form>
                                <div className="modal-body text-center">
                                    <span className="delete-icon">
                                        <i className="ti ti-trash-x" />
                                    </span>
                                    <h4>Confirm Deletion</h4>
                                    <p>
                                        You want to delete all the marked items, this cant be undone
                                        once you delete.
                                    </p>
                                    <div className="d-flex justify-content-center">
                                        <Link
                                            to="#"
                                            className="btn btn-light me-3"
                                            data-bs-dismiss="modal"
                                        >
                                            Cancel
                                        </Link>
                                        <Link
                                            to="#"
                                            data-bs-dismiss="modal"
                                            className="btn btn-danger"
                                        >
                                            Yes, Delete
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {/* /Delete Modal */}
            </>
        </div>
    );
};

export default WizklubTrainerSales;
